import { CmsApiImageBlockData } from 'modules/cms/api/types/CmsApiImage';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpImageBlock } from './CmsAmpImageBlock';
import { CmsImageBlock } from './CmsImageBlock';

export const CmsImageBlockMapping: CmsBlockMapping<CmsApiImageBlockData> = {
  invariant: [
    {
      prop: 'image',
      msg: 'Image data required for image',
    },
    {
      prop: 'width',
      msg: 'width required for image',
    },
  ],
  width: ({ width }: { width: 'WIDE' | 'NARROW' }) =>
    width === 'WIDE' ? CmsBlockWidth.GRID : CmsBlockWidth.NARROW,
  Component: CmsImageBlock,
  AmpComponent: CmsAmpImageBlock,
};
